/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './Renegociacao25Blog.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function Renegociacao25Blog() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="renegociacao-25-blog">
        <ContainerHome24>
          <div className="is-mobi">
            <h2 className="renegociacao-25-blog-titulo">Consulte nossos conteúdos</h2>
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`renegociacao-25-blog-slide ${className}`}>
                    <a
                      href="blog/contrato-em-atraso.html"
                      target="_blank"
                      className="renegociacao-25-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-13/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-13/capa.jpg" />
                        <img
                          src="static/amp/blog/post-13/capa.jpg"
                          alt="Casal preocupado olhando para as contas sobre uma mesa"
                        />
                      </picture>
                      <div className="renegociacao-25-blog-card-textos">
                        <h3 className="renegociacao-25-blog-slide-titulo">
                          Contrato em atraso, o que fazer?
                        </h3>
                        <p className="renegociacao-25-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`renegociacao-25-blog-slide ${className}`}>
                    <a
                      href="blog/renegociacao-de-veiculos-saiba-tudo-o-que-voce-precisa.html"
                      target="_blank"
                      className="renegociacao-25-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-30/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-30/capa.jpg" />
                        <img
                          src="static/amp/blog/post-30/capa.jpg"
                          alt="Mulher sorrindo em pé ao lado de empresário moderno fazendo um acordo de veículo no Santander"
                        />
                      </picture>
                      <div className="renegociacao-25-blog-card-textos">
                        <h3 className="renegociacao-25-blog-slide-titulo">
                          Renegociação de veículos no Santander: o que você precisa saber
                        </h3>
                        <p className="renegociacao-25-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`renegociacao-25-blog-slide ${className}`}>
                    <a
                      href="blog/renegociacao-de-financiamento-de-veiculo-no-santander-entenda.html"
                      target="_blank"
                      className="renegociacao-25-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-27/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-27/capa.jpg" />
                        <img
                          src="static/amp/blog/post-27/capa.jpg"
                          alt="Homem de óculos segurando um contrato do Santander mostrando como renegocia dívidas conversando com duas mulheres."
                        />
                      </picture>
                      <div className="renegociacao-25-blog-card-textos">
                        <h3 className="renegociacao-25-blog-slide-titulo">
                          Renegociação de financiamento de veículo no Santander: entenda
                        </h3>
                        <p className="renegociacao-25-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            <h2 className="renegociacao-25-blog-titulo">Consulte nossos conteúdos</h2>
            <div className="cards-desk">
              <a
                href="blog/contrato-em-atraso.html"
                target="_blank"
                className="renegociacao-25-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-13/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-13/capa.jpg" />
                  <img
                    src="static/amp/blog/post-13/capa.jpg"
                    alt="Casal preocupado olhando para as contas sobre uma mesa"
                  />
                </picture>
                <div className="renegociacao-25-blog-card-textos">
                  <h3 className="renegociacao-25-blog-slide-titulo">
                    Contrato em atraso, o que fazer?
                  </h3>
                  <p className="renegociacao-25-blog-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/renegociacao-de-veiculos-saiba-tudo-o-que-voce-precisa.html"
                target="_blank"
                className="renegociacao-25-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-30/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-30/capa.jpg" />
                  <img
                    src="static/amp/blog/post-30/capa.jpg"
                    alt="Mulher sorrindo em pé ao lado de empresário moderno fazendo um acordo de veículo no Santander"
                  />
                </picture>
                <div className="renegociacao-25-blog-card-textos">
                  <h3 className="renegociacao-25-blog-slide-titulo">
                    Renegociação de veículos no Santander: o que você precisa saber
                  </h3>
                  <p className="renegociacao-25-blog-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/renegociacao-de-financiamento-de-veiculo-no-santander-entenda.html"
                target="_blank"
                className="renegociacao-25-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-27/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-27/capa.jpg" />
                  <img
                    src="static/amp/blog/post-27/capa.jpg"
                    alt="Homem de óculos segurando um contrato do Santander mostrando como renegocia dívidas conversando com duas mulheres."
                  />
                </picture>
                <div className="renegociacao-25-blog-card-textos">
                  <h3 className="renegociacao-25-blog-slide-titulo">
                    Renegociação de financiamento de veículo no Santander: entenda
                  </h3>
                  <p className="renegociacao-25-blog-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default Renegociacao25Blog;
